
import * as netlifyRuntime$2xGLoGD2LP from '/opt/build/repo/node_modules/@nuxt/image/dist/runtime/providers/netlifyImageCdn'
import * as orieRuntime$yTgazahEsG from '/opt/build/repo/services/orie-nuxt-image-provider.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "netlify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['netlify']: { provider: netlifyRuntime$2xGLoGD2LP, defaults: {} },
  ['orie']: { provider: orieRuntime$yTgazahEsG, defaults: {"baseURL":"https://commerce.orie.market/media"} }
}
        